module.exports = __webpack_public_path__ + "img/review9pp.d4be94d0.png";